import type { ID, AppField } from "@smartsuite/smartsuite-client";
import type { ActivityRecord } from "../../../../../stores/jobs.store";
import type { FunctionComponent, ReactElement } from "react";
import { memo } from "react";
import { t } from "i18next";
import type { GridSettings } from "@smartsuite/grid/lib/Grid.types";
import { GridRowColumnsList } from "@smartsuite/grid/lib/components/GridRowFieldList/GridRowColumnsList";
import type { CellComponent, Side } from "@smartsuite/grid/lib/types";
import { GridRow } from "@smartsuite/grid/lib/components/GridRow/GridRow";
import type { Weight } from "@smartsuite/react-ui/lib";
import { Button, TextSizes } from "@smartsuite/react-ui/lib";

import { StyledDetails } from "./style";
import { GrayColors, IconColorNames, TextColorNames } from "@smartsuite/types";

const buttonDetailsStyles = {
  height: 24,
  sidePadding: 9,
  textSize: TextSizes.S,
  borderRadius: 4,
  borderWidth: 1,
  borderColor: GrayColors["G-1"],
  borderHoverColor: GrayColors["G-2"],
  background: GrayColors["G-0-5"],
  backgroundHover: GrayColors["G-1"],
  textColor: TextColorNames.primary,
  textWeight: "regular" as Weight,
  iconRightIndent: -3,
  iconLeftIndent: 0,
  iconColor: IconColorNames.dark,
};

interface ActivityGridRowProps {
  index: number;
  side: Side;
  record: ActivityRecord;
  fields: AppField[];
  top?: number;
  left?: number;
  height: number;
  settings: GridSettings;
  cellComponent: CellComponent<ActivityRecord, AppField>;

  onDetails: (id: ID) => void;
}

const ActivityGridRowRaw: FunctionComponent<ActivityGridRowProps> = ({
  record,
  fields,
  top,
  index,
  left,
  height,
  cellComponent,
  settings,
  onDetails,
}): ReactElement => {
  return (
    <GridRow
      className="activity-grid-row"
      index={index}
      record={record}
      top={top}
      left={left}
      height={height}
      side="right"
      settings={settings}
    >
      <GridRowColumnsList
        record={record}
        columns={fields}
        // @ts-expect-error
        cellComponent={cellComponent}
      />
      {/* Make translates */}
      {
        <StyledDetails>
          <Button
            iconName="arrow-down-small"
            isContentReversed={true}
            styles={buttonDetailsStyles}
            onClick={() => onDetails(record.id)}
          >
            {t("job-list.Details")}
          </Button>
        </StyledDetails>
      }
    </GridRow>
  );
};

export const ActivityGridRow = memo(ActivityGridRowRaw);
